import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Actions */
import {hideModal} from 'react-redux/actions/modal'

/* Styles */
import './modal.css'

/**
* Modal and Overlay
* Pass a component to as prop to nest it
*/
class Modal extends Component {

  componentDidMount() {
    this.locked = false
  }

  /**
  * Hide Modal
  */
  hideModal() {
    const { hideModal, locked } = this.props
    if(!locked) hideModal()
  }

  /**
  * Return component that was passed as prop
  */
  renderModal() {
    return this.props.component
  }

  render() {
    if (!this.props.component) return null
    return (
      <div className="modal component">
        <div
          className="overlay"
          onClick={ this.hideModal.bind(this) }>
        </div>
        { this.renderModal() }
      </div>
    )
  }
}

Modal.propTypes = {
  component: PropTypes.object // alternative to showModal, not yet tested
}

function mapStateToProps(state) {
  return state.modal
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      hideModal
    },
    dispatch
  )
}

const reduxComponent = connect(mapStateToProps, mapDispatchToProps)(Modal)
const translatedComponent = translate([], { withRef: true })(reduxComponent)
export default reduxComponent



// WEBPACK FOOTER //
// ./src/app/component/modal/modal.jsx